import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Button, Form, Input, Drawer, Select } from "antd";
import TEXTS from "../../../config/texts";
import { REQUESTS } from "../../../api/requests";
import country from "../../../country.json";
import Message from "../../../components/message";

export default function SubresellerDrawer({
  visible,
  onClose,
  current = null,
  getSubresellers,
}) {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({
    text: "",
    type: true,
  });
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const [inputValue, setInputValue] = useState('');

  const translation = useSelector((state) => state.globalState.translation);
  const inputRef = useRef(null);

  const [form] = Form.useForm();

  function onFinish(values) {
    setLoading(true);

    const body = {
      name: values.name,
      surname: values.surname || "",
      email: values.email,
      phone: inputValue,
      company: values.company || "",
      address: values.address || "",
      country: values.country || "",
    };
    
    if (values.password.length) {
      body.password = values.password;
    }

    if (current) {


      body["id"] = current.id;

      REQUESTS.SUBRESELLERS.EDIT(
        body,
        (data) => {
          setLoading(false);
          getSubresellers();
          onClose();
        },
        (err) => {
          setLoading(false);
          setMessage({
            text: err,
            type: false,
          });
        }
      );
    } else {
      REQUESTS.SUBRESELLERS.ADD(
        body,
        (data) => {
          setLoading(false);
          getSubresellers();
          onClose();
          setInputValue('')
        },
        (err) => {
          setLoading(false);
          setMessage({
            text: err,
            type: false,
          });
        }
      );
    }
  }

  const onSubmit = () => {
    form.submit();
    setMessage({
      text: "",
      type: true,
    });
  };

  const onValuesChange = () => {
    setMessage({
      text: "",
      type: true,
    });
  };

  useEffect(() => {
    if (current) {
      form.setFields([
        {
          name: "name",
          value: current.name,
        },

        {
          name: "surname",
          value: current.surname,
        },

        {
          name: "company",
          value: current.company,
        },

        {
          name: "country",
          value: current.country,
        },
        {
          name: "email",
          value: current.email,
        },

        {
          name: "address",
          value: current.address,
        },

        {
          name: "password",
          value: "",
        },
      ]);

      setInputValue(current.phone)
    } else {
      form.resetFields();
      setInputValue("")
    }
  }, [current, visible]);

  useEffect(() => {
    if (!visible) {
      setMessage({
        text: "",
        type: true,
      });
    }
  }, [visible]);

  useEffect(() => {
    const windowSize = () => setWindowWidth(window.innerWidth);

    window.addEventListener("resize", windowSize);

    return () => window.removeEventListener("resize", windowSize);
  }, []);

  return (
    <div>
      <Drawer
        width={windowWidth > 600 ? 600 : "75vw"}
        title={
          current
            ? translation["Edit Reseller"] || TEXTS["Edit Reseller"]
            : translation["Add Reseller"] || TEXTS["Add Reseller"]
        }
        placement="right"
        onClose={onClose}
        open={visible}
      >
        <Form
          form={form}
          name="profile"
          layout="vertical"
          onFinish={onFinish}
          onValuesChange={onValuesChange}
        >
          <div className="subreseller-drawer-content">
            <Form.Item
              label={translation["Name"] || TEXTS["Name"]}
              name="name"
              rules={[
                {
                  required: true,
                  message: translation["This field is required!"] || TEXTS["This field is required!"],
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="surname"
              label={translation["Surname"] || TEXTS["Surname"]}

            >
              <Input />
            </Form.Item>
            <div className="phone-inp-container">
              <label className="phone-label">{translation["Phone"] || TEXTS["Phone"]}</label>
              <input type="text" value={inputValue} ref={inputRef} name="phone" onChange={(e) => {
                const validInput = e.target.value.replace(/[^+0-9]/g, '');
                if (validInput.includes('+')) {
                  setInputValue(validInput);
                } else {
                  setInputValue(`+${validInput}`);
                }
              }}
                onKeyDown={(e) => {
                  const cursorPosition = inputRef.current.selectionStart;
                  if (cursorPosition == 0) {
                    inputRef.current.selectionStart = e.target.value.length;
                  }
                }}
                className="phone-input"
              />
            </div>

            <Form.Item
              name="email"
              label={translation["Email"] || TEXTS["Email"]}
              rules={[
                {
                  required: true,
                  message: translation["This field is required!"] || TEXTS["This field is required!"],
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="company"
              label={translation["Company"] || TEXTS["Company"]}

            >
              <Input />
            </Form.Item>

            <Form.Item
              name="address"
              label={translation["Address"] || TEXTS["Address"]}

            >
              <Input />
            </Form.Item>
            <Form.Item
              name="country"
              label={translation["Country"] || TEXTS["Country"]}

            >
              <Select showSearch={true}>
                {country.map((item) => {
                  return (
                    <Select.Option key={item.code} value={`${item.name}`}>
                      {item.name}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              name="password"
              label={translation["Password"] || TEXTS["Password"]}
              rules={[
                {
                  required: !current,
                  message: translation["This field is required!"] || TEXTS["This field is required!"],
                },
              ]}
            >
              <Input.Password />
            </Form.Item>
          </div>{" "}
          <Message message={message} />
          <Form.Item>
            <div className="subreseller-drawer-content_save-btn-container">
              <Button
                type="primary"
                onClick={onSubmit}
                loading={loading}
                className="subreseller-drawer-content_save-btn-container_btn"
              >
                {translation["Save"] || TEXTS["Save"]}
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Drawer>
    </div>
  );
}
